import { boolean, date, number, object, string } from 'yup'

const LexusReserveSchema = object().shape({
  type_of_enquiry: string(),
  form_name: string().required('Form name is required'),
  enquiry_description: string(),
  reg_num: string().required('Registration number is required').trim(),
  response_code: string().trim(),
  title: string()
    .required('Title is required')
    .min(1, 'Title must be at least 2 characters')
    .max(10, 'Title must be at most 10 characters')
    .trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,30}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(30, 'First name must be at most 30 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,30}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(30, 'Last name must be at most 30 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .required('Phone is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  address_line1: string().required('Address Line 1 is required').trim(),
  address_line2: string().trim(),
  town: string().required('Town is required').trim(),
  county: string().trim(),
  postcode: string()
    .required('Postcode is required')
    .trim()
    .matches(
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
      'Postcode must be a valid UK postcode',
    ),
  travel_abroad: boolean().required(),
  date_to_input: date()
    .typeError('Please select a date')
    .required('Please select a date'),
  date_from_input: date()
    .typeError('Please select a date')
    .required('Please select a date'),
  model_interest: string().required('Model is required').trim(),
  dealer: number().required('Dealer is required'),
  travel_countries: string()
    .trim()
    .when('travel_abroad', {
      is: true,
      then: (rule) =>
        rule.required(
          'Please provide details of the countries you intend to travel to/through',
        ),
    }),
  notes: string().trim(),
  Lexus_reserve_tandcs: boolean().oneOf(
    [true],
    'Please read and accept the terms and conditions',
  ),
  dealer_name: string().trim(),
})

export default LexusReserveSchema
